import React from 'react'
import { styled } from 'linaria/react'

const FilterButtonWrapper = styled.div`
   & {
      width: 100%;
      background: var(--color-white);
   }
   .filter-button {
      height: 40px;
      background-color: #545454;
      border-radius: 4px;
   }
`;

const FilterButtonsSkeleton = () => {
   return (
      <FilterButtonWrapper>
         <div className="filter-buttons d-flex gap-2 py-8 pr-128">
            <div className="filter-button w-100 placeholder placeholder-wave"></div>
         </div>
      </FilterButtonWrapper>
   );
};

export default FilterButtonsSkeleton;